const SET_DOWNLOADCONFIG = 'scratch-gui/downloadAlert/set_downloadConfig'
const SET_JSONDATA = 'scratch-gui/downloadAlert/set_json_data'

const initialState = {
    donwloadConfig: {
        show: false,
        content: 'No Content',
        type: 'Info',
    },
    JSON_VALUE:{

    }
}
const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
        case SET_DOWNLOADCONFIG: {
            return Object.assign({}, state, {
                donwloadConfig: {
                    ...action.config
                }
            })
        }
        case SET_JSONDATA: {
            return Object.assign({}, state, {
                JSON_VALUE: {
                    ...action.json
                }
            })
        }
        default:
            return Object.assign({}, state)

    }
}
const setConfig = function (config) {
    return {
        type: SET_DOWNLOADCONFIG,
        config
    }
}
const setJSON = function (json) {
    return {
        type: SET_JSONDATA,
        json
    }
}
export {
    reducer as
    default,
    initialState as downloadInitialState,
    setConfig,
    setJSON
}
